export default "/images/framework/PlayerLink.7e44245e.svg?7e44245e";